var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 35,
    viewBox: "0 0 30 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 34.1918C23.2843 34.1918 30 26.5377 30 17.0959C30 7.65409 23.2843 0 15 0C6.71573 0 0 7.65409 0 17.0959C0 26.5377 6.71573 34.1918 15 34.1918Z",
    fill: "#58B0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2891 21.4003L19.0109 21.4673V28.6144L11.2891 28.5474V21.4003Z",
    fill: "#F9DCA4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.345 32.5901C19.3822 33.632 17.245 34.1783 15.0798 34.1916C12.9146 34.205 10.7724 33.6851 8.7998 32.6675V26.7874H21.3445L21.345 32.5901Z",
    fill: "#E6E6E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.215 34.1366C15.8144 34.1732 15.4094 34.1916 15 34.192C14.6909 34.192 14.3843 34.1815 14.0801 34.1604L14.5801 29.1877H15.75L16.215 34.1366Z",
    fill: "#E9573E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4548 33.933C10.801 33.5819 9.20377 32.9454 7.71839 32.0452C6.29167 31.1404 5.0035 29.9772 3.9043 28.6012L4.5276 26.886L11.2873 23.4491C11.2873 26.3328 12.1179 30.9077 12.4548 33.933Z",
    fill: "#677079"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0127 21.4441V23.2317C16.7156 26.2896 12.3268 25.8569 11.3428 21.3439L19.0127 21.4441Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1111 4.66501C25.4417 4.66501 21.4154 24.1765 15.1111 24.1765C9.15618 24.1765 4.78044 4.66501 15.1111 4.66501Z",
    fill: "#FFE8BE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.91501 13.3038C7.42472 14.0446 8.69171 17.5562 9.62958 17.5407C9.24056 16.1668 9.00058 14.7443 8.91501 13.3038Z",
    fill: "#F9DCA4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4279 13.3033C22.9182 14.0441 21.6512 17.5562 20.7139 17.5402C21.1026 16.1663 21.3424 14.7435 21.4279 13.3033Z",
    fill: "#F9DCA4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6463 7.9272C9.02786 9.8404 9.59728 15.1363 9.59728 15.1363L9.08757 14.8624C5.90601 0.812745 24.4439 0.812191 21.2444 14.8624L20.7347 15.1363C20.7347 15.1363 21.3046 9.8404 19.6861 7.9272C17.6866 10.1375 12.6347 10.1259 10.6463 7.9272Z",
    fill: "#464449"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8477 33.8838C21.1279 33.1618 24.1023 31.2109 26.2982 28.3412L25.769 26.8855L19.0098 23.4486C19.0098 26.3323 18.1846 30.8585 17.8477 33.8838Z",
    fill: "#677079"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0107 23.2262L15.1631 26.803L18.3539 30.0745C18.3539 30.0745 19.2044 24.7056 19.0107 23.2262Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.288 23.2262L15.1661 26.803L11.9404 30.0745C11.9404 30.0745 11.0928 24.7056 11.288 23.2262Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6445 28.3422L15.1674 26.7831L16.6902 28.3422L15.1674 29.9008L13.6445 28.3422Z",
    fill: "#E9573E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5081 33.9556C11.8882 33.8374 11.2755 33.6748 10.6736 33.4687C10.6547 33.4522 10.6363 33.435 10.6183 33.4173L8.90223 29.8819L11.1066 28.0782H8.7998L9.2935 24.2878L11.2886 22.8499C11.3751 26.9274 12.1425 31.5118 12.5081 33.9556Z",
    fill: "#434955"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7891 33.8964C18.0745 33.8422 18.357 33.7669 18.6371 33.6839C18.9682 33.586 19.2973 33.4754 19.6245 33.3636L19.6896 33.3398L21.3939 29.8459L19.1896 28.0522H21.4964L21.0027 24.2806L19.0075 22.8499C18.9211 26.9064 18.1541 31.4648 17.7891 33.8964Z",
    fill: "#434955"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.b502d75bfb2f6fa5c4f02a38a5c0191b.svg";
export { ForwardRef as ReactComponent };